import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TransactionDto } from '@dto/transactionDto';
import { DeliveryNote } from '@models/deliveryNote';
import { TableColumn } from '@models/tableColumn';
import { TableOptions } from '@models/tableOptions';
import { Transaction } from '@models/transaction';
import { DeliveryNotesService } from '@services/entity/delivery-notes.service';
import { TransactionsService } from '@services/entity/transactions.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import { DEDatePipe } from 'src/app/pipes/de-date.pipe';
import { ThousandPipe } from 'src/app/pipes/thousand.pipe';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-delivery-note',
  templateUrl: './create-delivery-note.component.html',
  styleUrls: ['./create-delivery-note.component.scss']
})
export class CreateDeliveryNoteComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'CreateDeliveryNoteComponent';

  @Input() public transactions: TransactionDto[];
  @Input() public userId: string;
  @Input() public customerId: number;

  @Output() newEntityEvent = new EventEmitter<DeliveryNote>();

  public entities: TransactionDto[];

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn1:Trans-ID`, property: 'transactionId' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn2:Vorname`, property: 'userFirstName' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn3:Nachname`, property: 'userLastName' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn4:Ladestation`, property: 'chargingStationName' },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn5:Lademenge in kWh`, property: 'meterAmount', options: { columnPipe: { pipe: new ThousandPipe(new DecimalPipe('de-DE')) } } },
    { columnDescription: $localize`:@@CreateDeliveryNoteTableColumn6:Datum`, property: 'startTimestamp', options: { columnPipe: { pipe: new DEDatePipe() } } },
  ];

  public tableOptions: TableOptions = { hideActions: true, hideSearch: true, showCheckboxes: true };

  constructor(
    public deliveryNotesService: DeliveryNotesService,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector
  ) {
    super(deliveryNotesService, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.tableFunctions.pageSize = 999999;
    this.tableFunctions.sortColumn = 'transactionId';
    this.tableFunctions.sortDirection = 'desc';

    this.entities.forEach(e => {
      this.tableFunctions.selectedEntities.push(e);
    })

    this.createForm();
  }

  initializeEntities() {
    this.entities = this.transactions;
    super.setupTable();
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

  createForm() {
    this.formService.form = new UntypedFormGroup({
      deliveryNoteNumber: new UntypedFormControl(),
    });
  }

  onSubmit(formValue, download:boolean = false) {

    var deliveryNote = new DeliveryNote(formValue);
    deliveryNote.transactions = this.tableFunctions.selectedEntities as Transaction[];
    deliveryNote.userId = this.userId;
    deliveryNote.customerId = this.customerId;

    this.deliveryNotesService.createEntity(deliveryNote).subscribe(result => {
      this.newEntityEvent.emit(deliveryNote);
      if(download)
       this.downloadPdf(result.id, result.deliveryNoteNumber);
    }, error => {
      this.toastService.error($localize`:@@CreateDeliveryNoteErrorTitle:Fehler beim Erstellen des Lieferscheins.`)
      this.messageService.setError(error);
    })

  }

  downloadPdf(deliveryNoteId:number, deliveryNoteNumber:string ) {
    this.toastService.loading(`Lieferschein wird heruntergeladen...`)
    console.log("deliveryNoteId",deliveryNoteId);
    console.log("deliveryNoteNumber",deliveryNoteNumber);

    this.deliveryNotesService.getDeliveryNotePdf(deliveryNoteId).subscribe((response: any) => {
      try {
        const file = new Blob([response], { type: 'application/pdf' });
        const fileUrl = URL.createObjectURL(file);

        var a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileUrl;
        a.download = deliveryNoteNumber;
        a.click();

        window.open(fileUrl);
      } catch (error) {
        console.error(error);
        this.toastService.error(`Lieferschein konnte nicht heruntergeladen werden.`, 0, true)
      } finally {
        this.toastService.clear()
      }
    }, error => {
      console.error(error);
      this.toastService.error(`Lieferschein konnte nicht heruntergeladen werden.`, 0, true)
    })
  }

  openErrorDialog(text) {
    Swal.fire({
      title: $localize`:@@CreateDeliveryNoteErrorTitle:Fehler beim Erstellen des Lieferscheins!`,
      text: text,
      icon: 'error',
      confirmButtonText: $localize`:@@CreateDeliveryNoteErrorConfirm:Zurück`,
      confirmButtonColor: 'red'
    })
  }
}
